import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { TraitementEnCoursEnum } from "../../../dto/GenApi.iNotPaie.Dto/TraitementEnCoursEnum";
import { TraitementEnCoursDto } from "../../../dto/GenApi.iNotPaie.Dto/TraitementEnCoursDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametrageModuleEnum } from "../../../dto/GenApi.iNotPaie.Dto/ParametrageModuleEnum";
import { ParametrageModuleIdEnum } from "../../../dto/GenApi.iNotPaie.Dto/ParametrageModuleIdEnum";
import { EventBus } from "../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";

@Component
export default class ModalTraitementEnCours extends Vue {
	public title?: string = "";
	public message?: string = "";

	public timerId: any = undefined;
	public isAdministrateur = false;

	public init(dto: TraitementEnCoursDto): void {
    	this.title = dto.Description;
    	this.message = "Une opération est en cours, merci de patienter un instant. L'application se rafraichira automatiquement à la fin du processus.";
    	this.initTimer();
    	$("#modalTraitementEnCours").modal({ backdrop: "static" });
    	this.isAdministrateur = ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
	}

	public initTimer(): void {
    	this.timerId = setInterval(this.verifierEtatPaie, 20000);
	}

	public verifierEtatPaie(): any {
    	ServicesFactoryInstance.ParametrageModuleService.getParametrageModule(ParametrageModuleEnum.GENERAL, ParametrageModuleIdEnum.TRAITEMENT_EN_COURS, data => {
    		if (data.StrData == TraitementEnCoursEnum[TraitementEnCoursEnum.Aucun]) {
    			EventBus.$emit(EventConstants.TRAITEMENT_FINISHED);
    			this.fermer();
    		}
    	});
	}

	public debloquerSituation(): void {
    	ServicesFactoryInstance.ParametrageModuleService.debloquerTraitementEnCours(this.verifierEtatPaie);
	}

	public fermer(): void {
    	setTimeout(() => {
    		clearInterval(this.timerId);
    		$("#modalTraitementEnCours").modal("hide");
    	}, 1000);
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalTraitementEnCours/modalTraitementEnCours.ts